import React from 'react'
import { useGetCustomer } from '../../../hooks/apolloHooks/useGetCustomer'
import { GET_CUSTOMER_RIGHTS_DATA_QUERY } from '../../../integrations/allkort/graphql/gql/CustomerQueries'
import { CustomerRightsDataResponse } from '../../../integrations/allkort/graphql/interface/Customer'
import { ArrowRightIcon, BlockIcon, PadlockIcon, SingleCardIcon, SupportIcon } from '../../svgs/ExpressonSVGs'
import Link from '../Link'

type QuickLinksProps = {
    hasAtLeastOneActiveCard: boolean
    hasSmartCard?: boolean
}

const QuickLinks: React.FC<QuickLinksProps> = ({ hasAtLeastOneActiveCard, hasSmartCard }) => {
    const { data: currentCustomerData, loading: currentCustomerLoading, error: currentCustomerError } = useGetCustomer<CustomerRightsDataResponse>(
        GET_CUSTOMER_RIGHTS_DATA_QUERY,
        {},
        { fetchPolicy: 'network-only' }
    );

    const isFrozen = currentCustomerData?.currentCustomer?.frozen?.is ?? false;
    return (
        <div className="quicklinks-component quick-links-component">
            <h5 className="quick-links-component__heading body-text">Snabblänkar</h5>

            <div className="quick-links-component__links">
                {!currentCustomerLoading && hasAtLeastOneActiveCard && !isFrozen && (
                    <div className="quick-link-item">
                        <span className="svg-icon-wrapper round purple">
                            <PadlockIcon width={24} height={24} />
                        </span>
                        <Link href="/kort">
                            Ändra PIN-kod
                            <ArrowRightIcon width={22} height={22} />
                        </Link>
                    </div>
                )}

                {hasAtLeastOneActiveCard && (
                    <div className="quick-link-item">
                        <span className="svg-icon-wrapper round red">
                            <BlockIcon width={24} height={24} />
                        </span>
                        <Link href="/kort">
                            Spärra kort
                            <ArrowRightIcon width={22} height={22} />
                        </Link>
                    </div>
                )}

                {/* TODO: if user dont have rights link should not appear */}
                {/*<div className="quick-link-item">
                    <span className="svg-icon-wrapper round gray-contrast">
                        <PeopleGroupIcon width={24} height={24} />
                    </span>
                    <Link href="/mitt-konto/hantera-anvandare">
                        Hantera användare
                        <ArrowRightIcon width={22} height={22} />
                    </Link>
                </div>*/}

                {hasSmartCard && (
                    <div className="quick-link-item">
                        <span className="svg-icon-wrapper round blue">
                            <SingleCardIcon width={24} height={24} />
                        </span>
                        <Link href="/mitt-konto/fakturor-kontobesked#statements">
                            Fyll på smarkortsaldo
                            <ArrowRightIcon width={22} height={22} />
                        </Link>
                    </div>
                )}


                <div className="quick-link-item">
                    <span className="svg-icon-wrapper round orange">
                        <SupportIcon width={24} height={24} />
                    </span>
                    <Link href="/kontakt">
                        Kundservice
                        <ArrowRightIcon width={22} height={22} />
                    </Link>
                </div>

            </div>
        </div>
    )
}

export default QuickLinks;